import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { aciesDateFormat } from '@shared/helpers';
import { NotificationService } from '@shared/services/notification.service';
import { IClearSweepMarksResponse } from '../sync-monitoring.models';
import { SyncMonitoringService } from '../sync-monitoring.service';

/** The items to keep, all marked by one run at one version; `otherCount` is how many other items of the table keep their mark. */
export interface IKeepMarksDialogData {
	environmentId: string;
	tableName: string;
	version: string;
	runId: string;
	expiresAt: number | null;
	keys: string[];
	otherCount: number;
}

/** Clears the expiry mark on exactly the listed items, so they stay in One, and closes with the API's answer. */
@Component({
	selector: 'app-keep-marks-dialog',
	templateUrl: './keep-marks-dialog.component.html',
	styleUrls: ['../audit-dialogs.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class KeepMarksDialogComponent {
	public isLoading = false;
	public readonly expiresAt: string;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IKeepMarksDialogData,
		public dialogRef: MatDialogRef<KeepMarksDialogComponent, IClearSweepMarksResponse>,
		private syncMonitoringService: SyncMonitoringService,
		private notificationService: NotificationService,
	) {
		this.expiresAt = data.expiresAt != null ? aciesDateFormat(new Date(data.expiresAt), true, true) : '—';
	}

	onConfirm(): void {
		if (this.isLoading) {
			return;
		}
		this.isLoading = true;
		this.dialogRef.disableClose = true;
		const request = { version: this.data.version, markedByRunId: this.data.runId, keys: this.data.keys };
		this.syncMonitoringService.clearSweepMarks(this.data.environmentId, this.data.tableName, request).subscribe({
			next: (response) => this.dialogRef.close(response),
			error: () => {
				this.isLoading = false;
				this.dialogRef.disableClose = false;
				this.notificationService.notify(['administration.sync-monitoring.keep-dialog.errors.clear-failed'], [], 'error');
			},
		});
	}

	onCancel(): void {
		this.dialogRef.close();
	}
}
